<template>
  <el-dialog title="配置选项" v-model="dialogShow" size="small">
    <div>
      <span v-for="item in configData">
        <el-button class="m-l-10 m-t-10" @click="goConfig(item)">{{item.name}}</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import mobileConfig from 'config/mobileConfig'
export default {
  name: 'configuration',
  props: {
    configData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogShow: false
    }
  },
  methods: {
    goConfig(item) {
      let routeName = ''
      switch (item.type) {
        case this.COM_CONTENT: // 图文内容显示
          routeName = 'contentConfig'
          break
        case this.COM_TOTOP:   // 返回顶部按钮
          routeName = 'goTop'
          break
        case this.COM_FORM_INFO:   // 返回顶部按钮
          routeName = 'box'
          break
      }
      router.push({ name: routeName, params: { id: item.id, pageId: item.page_id }})
    }
  },
  mixins: [mobileConfig]
}
</script>


// WEBPACK FOOTER //
// configuration.vue?ade78ed4